import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Spinner } from "react-bootstrap";
import format from "date-fns/format";
import {
  getSystemLogApi,
  getSystemLogExportApi,
} from "../../services/LogService";
import Pagination from "../Constant/Pagination";
import { DetailsDialog } from "./DetailsDialog";
import { MdOutlineKeyboardDoubleArrowRight } from "react-icons/md";
import DebounceSmallSearchInput from "../Constant/DebounceSmallSearchInput";
import { CancelRequest } from "../../services/AxiosInstance";
import DatePicker from "react-datepicker";
import { FaDownload } from "react-icons/fa";
import { subDays, startOfMonth, endOfMonth, subMonths } from "date-fns";
import { dateRangeOptions } from "../../utilities";
import GlobalSearchableDropdown from "../Constant/SearchableDropdown";
import { toast } from "react-toastify";
const SystemLog = () => {
  const [data, setData] = useState([]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [total, setToatl] = useState(0);
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedDetails, setSelectedDetails] = useState(null);
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [selectedOption, setSelectedOption] = useState(dateRangeOptions[1]);
  const [exportLoading, setExportLoading] = useState(false);
  const handleOpenDialog = (details) => {
    setSelectedDetails(details);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setSelectedDetails(null);
  };
  const [param, setParam] = useState({
    page: "1",
    page_size: "10",
    start_date: format(subDays(new Date(), 7), "yyyy-MM-dd"),
    end_date: format(new Date(), "yyyy-MM-dd"),
  });

  const getData = () => {
    setLoading(true);
    getSystemLogApi(param)
      .then((res) => {
        setError("");
        setData(res?.data?.results || []);
        setToatl(res?.data?.count || 0);
      })
      .catch((err) => {
        setError(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      })
      .finally(() => {
        setLoading(false);
      });
  };
  useEffect(() => {
    getData();
  }, [param]);
  const handlePageChange = (page) => {
    setParam((prev) => ({
      ...prev,
      page: page.selected + 1,
    }));
  };

  const handleSearchChange = (value) => {
    if (value.length > 0) CancelRequest();
    setParam((prev) => ({
      ...prev,
      query: value,
      page: 1,
    }));
  };
  const handleDateRangeChange = (option) => {
    setSelectedOption(option);
    if (!option) {
      setParam({ ...param, start_date: "", end_date: "", page: "1" });
      return;
    }
    let startDate,
      endDate = new Date();
    switch (option.value) {
      case "yesterday":
        startDate = subDays(new Date(), 1);
        endDate = startDate;
        break;
      case "7_days":
        startDate = subDays(new Date(), 7);
        break;
      case "15_days":
        startDate = subDays(new Date(), 15);
        break;
      case "15_days":
        startDate = subDays(new Date(), 15);
        break;
      case "30_days":
        startDate = subDays(new Date(), 30);
        break;
      case "last_month":
        startDate = startOfMonth(subMonths(new Date(), 1));
        endDate = endOfMonth(subMonths(new Date(), 1));
        break;
      case "3_months":
        startDate = startOfMonth(subMonths(new Date(), 3));
        endDate = endOfMonth(subMonths(new Date(), 1));
        break;
      case "custom":
        setShowDatePicker(true);
        return;
      default:
        return;
    }
    setShowDatePicker(false);
    setParam({
      ...param,
      start_date: format(startDate, "yyyy-MM-dd"),
      end_date: format(endDate, "yyyy-MM-dd"),
      page: "1",
    });
  };

  const handleExport = () => {
    setExportLoading(true);
    getSystemLogExportApi({ ...param, export: true })
      .then((res) => {
        const blob = new Blob([res.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        const url = window.URL.createObjectURL(blob);

        const a = document.createElement("a");
        a.href = url;
        a.download = "System-Log.xlsx";

        // Append to DOM to make it more consistent
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);

        window.URL.revokeObjectURL(url);
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      })
      .finally(() => {
        setExportLoading(false);
      });
  };
  return (
    <div>
      <div className="mb-3 d-flex justify-content-between align-items-center">
        <div>
          <h2 className="text-primary">System Log</h2>
          <ol className="breadcrumb breadcrumb-arrow mb-0">
            <li className="breadcrumb-item">
              <Link to="/dashboard">Dashboard</Link>
            </li>
            <li className="breadcrumb-item active">System Log</li>
          </ol>
        </div>
        <div>
          {/* <button
            className="btn btn-success d-flex align-items-center gap-1 align-self-center"
            disabled={exportLoading}
            onClick={handleExport}
          >
            {exportLoading ? (
              <Spinner animation="border" size="sm" />
            ) : (
              <FaDownload />
            )}
            Export
          </button> */}
        </div>
      </div>
      <div className="card">
        <div className="p-4 d-flex justify-content-between gap-2 flex-column flex-md-row">
          <div className="flex-fill flex-md-grow-0">
            <DebounceSmallSearchInput handleSearchChange={handleSearchChange} />
          </div>
          <div className="d-flex flex-column flex-md-row gap-2">
            {showDatePicker && (
              <div className="flex-fill flex-md-grow-0">
                <DatePicker
                  selectsRange
                  startDate={
                    param?.start_date ? new Date(param.start_date) : null
                  }
                  endDate={param?.end_date ? new Date(param.end_date) : null}
                  onChange={(update) => {
                    const [start, end] = update;
                    setParam((prev) => ({
                      ...prev,
                      start_date: start ? format(start, "yyyy-MM-dd") : "",
                      end_date: end ? format(end, "yyyy-MM-dd") : "",
                      page: 1,
                    }));
                  }}
                  isClearable
                  placeholderText="Select date range"
                  className="form-control"
                  style={{
                    fontSize: "0.5rem",
                  }}
                />
              </div>
            )}
            <div>
              <GlobalSearchableDropdown
                options={dateRangeOptions}
                selected={selectedOption}
                onSelect={handleDateRangeChange}
                placeholder="Period"
                isClearable={false}
              />
            </div>
          </div>
        </div>
        {loading ? (
          <div className="text-center my-4">
            <Spinner animation="border" variant="primary" />
          </div>
        ) : error ? (
          <div className="text-center text-danger my-4">{error}</div>
        ) : data && data.length > 0 ? (
          <div className="table-responsive">
            <table className="table fs-6 mb-0 align-middle">
              <thead className="table-light custom-thead">
                <tr>
                  <th>Date</th>
                  <th>Performed By</th>
                  <th>Action</th>
                  <th>Message</th>
                  <th>Details</th>
                </tr>
              </thead>
              <tbody>
                {data.map((item, index) => (
                  <tr key={index}>
                    <td>
                      {item?.created_at
                        ? format(item?.created_at, "dd MMM yyy hh:mm a")
                        : "-"}
                    </td>
                    <td>{item?.performed_by?.name || "-"}</td>
                    <td>{item?.action.replace(/_/g, " ") || "-"}</td>
                    <td>{item?.message || "-"}</td>
                    <td>
                      {" "}
                      <button
                        className="btn rounded-2 btn-sm stylish-transparent-btn "
                        style={{ padding: "0.1rem 0.6rem" }}
                        onClick={() => handleOpenDialog(item)}
                      >
                        Details
                        <MdOutlineKeyboardDoubleArrowRight className="ms-1"/>
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <div className="text-center my-4">
            <span>No data found</span>
          </div>
        )}

        {!loading && data?.length > 0 && (
          <div className="p-4">
            <Pagination
              currentPage={param.page}
              recordsPage={param.page_size}
              dataLength={total}
              handlePagination={handlePageChange}
            />
          </div>
        )}
      </div>

      <DetailsDialog
        open={openDialog}
        onClose={handleCloseDialog}
        data={selectedDetails}
      />
    </div>
  );
};

export default SystemLog;
